import React from 'react';

const StatusBadge = ({ status, className = '' }) => {
  const getStatusStyle = (status) => {
    const normalizedStatus = status?.toLowerCase().replace(/[_-]/g, '') || 'scheduled';
    
    const statusStyles = {
      'completed': {
        bg: 'bg-green-100',
        text: 'text-green-700',
        border: 'border-green-300',
        icon: '✅'
      },
      'done': {
        bg: 'bg-green-100',
        text: 'text-green-700',
        border: 'border-green-300',
        icon: '✅'
      },
      'cancelled': {
        bg: 'bg-red-100',
        text: 'text-red-700',
        border: 'border-red-300',
        icon: '❌'
      },
      'canceled': {
        bg: 'bg-red-100',
        text: 'text-red-700',
        border: 'border-red-300',
        icon: '❌'
      },
      'inprogress': {
        bg: 'bg-yellow-100',
        text: 'text-yellow-700',
        border: 'border-yellow-300',
        icon: '🔄'
      },
      'in progress': {
        bg: 'bg-yellow-100',
        text: 'text-yellow-700',
        border: 'border-yellow-300',
        icon: '🔄'
      },
      'inqueue': {
        bg: 'bg-blue-100',
        text: 'text-blue-700',
        border: 'border-blue-300',
        icon: '⏳'
      },
      'scheduled': {
        bg: 'bg-blue-100',
        text: 'text-blue-700',
        border: 'border-blue-300',
        icon: '📅'
      },
      'confirmed': {
        bg: 'bg-blue-100',
        text: 'text-blue-700',
        border: 'border-blue-300',
        icon: '✓'
      },
      'checkedin': {
        bg: 'bg-[#2D869C]',
        text: 'text-white',
        border: 'border-[#2D869C]',
        icon: '✓'
      }
    };
    
    return statusStyles[normalizedStatus] || statusStyles['scheduled'];
  };

  const formatStatusText = (status) => {
    if (!status) return 'Pending';
    return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replace(/_|-/g, ' ');
  };

  const style = getStatusStyle(status);

  return (
    <div
      className={`
        inline-flex items-center px-3 py-1.5 rounded-lg text-sm font-semibold border-2 shadow-sm
        ${style.bg} ${style.text} ${style.border} ${className}
      `}
    >
      <span className="mr-1.5">{style.icon}</span>
      {formatStatusText(status)}
    </div>
  );
};

export default StatusBadge;
